import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../Components/CustomSnackbar';
import { LoadingLogs } from '../LoadingData/LoadingLog';
import { CABLE, CABLE_FLAG, COUPLING, COUPLING_FLAG, FOB, FOB_FLAG, NODE_PASSIVE_FLAG, PASSIVE_NODE, PILLAR, PILLAR_FLAG, PON_BOX, PON_BOX_FLAG, WELL, WELL_FLAG } from '../Constants/ConstantsOptics';

const ModalLog = ({ open, onClose, user }) => {
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState('mine'); // по умолчанию "мои"
  
  useEffect(() => {
    if (open) {
      LoadingLogs(setLogs, showSnackbar);
      setFilter('mine'); 
    }
  }, [open]);

   // 🔍 Фильтрация логов по текущему фильтру
  const filteredLogs = logs.filter(log => {
    if (filter === 'mine') return log.authorId === user;
    if (filter === CABLE) return log.relevantType === CABLE_FLAG && log.authorId === user;
    if (filter === COUPLING) return log.relevantType === COUPLING_FLAG && log.authorId === user;
    if (filter === FOB) return log.relevantType === FOB_FLAG && log.authorId === user;
    if (filter === PON_BOX) return log.relevantType === PON_BOX_FLAG && log.authorId === user;
    if (filter === WELL) return log.relevantType === WELL_FLAG && log.authorId === user;
    if (filter === PILLAR) return log.relevantType === PILLAR_FLAG && log.authorId === user;
    if (filter === PASSIVE_NODE) return log.relevantType === NODE_PASSIVE_FLAG && log.authorId === user;
    return true; // 'all'
  });

    return (
    <Dialog open={open} className="modalStyle">
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset', textShadow: '2px 2px 4px #242424' }}>
          Логи
        </label>
         {/* 🔘 Радиокнопки фильтра */}
        <RadioGroup
          row
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{ marginBottom: '5px', color: 'white' }}
        >

          <FormControlLabel
            value="all"
            control={
              <Radio
                sx={{
                  color: '#4188f3',
                  '&.Mui-checked': {
                    color: '#4188f3',
                  },
                  transform: 'scale(0.8)',
                  padding: '2px',
                }}
              />
            }
            label="Все"
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />

          <FormControlLabel
            value="mine"
            control={
              <Radio
                sx={{
                  color: '#dfab01', 
                  '&.Mui-checked': {
                    color: '#dfab01', 
                  },
                  transform: 'scale(0.8)', 
                  padding: '2px',
                }}
              />
            }
            label="Мои"
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />
          
          <FormControlLabel
            value={CABLE}
            control={
              <Radio
                sx={{
                  color: '#dfab01',
                  '&.Mui-checked': {
                    color: '#dfab01',
                  },
                  transform: 'scale(0.8)',
                  padding: '2px',
                }}
              />
            }
            label="Кабель"
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />

           <FormControlLabel
            value={COUPLING}
            control={
              <Radio
                sx={{
                  color: '#dfab01',
                  '&.Mui-checked': {
                    color: '#dfab01',
                  },
                  transform: 'scale(0.8)',
                  padding: '2px',
                }}
              />
            }
            label={COUPLING_FLAG}
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />

           <FormControlLabel
            value={FOB}
            control={
              <Radio
                sx={{
                  color: '#dfab01',
                  '&.Mui-checked': {
                    color: '#dfab01',
                  },
                  transform: 'scale(0.8)',
                  padding: '2px',
                }}
              />
            }
            label={FOB_FLAG}
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />

           <FormControlLabel
            value={PON_BOX}
            control={
              <Radio
                sx={{
                  color: '#dfab01',
                  '&.Mui-checked': {
                    color: '#dfab01',
                  },
                  transform: 'scale(0.8)',
                  padding: '2px',
                }}
              />
            }
            label={PON_BOX_FLAG}
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />

          <FormControlLabel
            value={WELL}
            control={
              <Radio
                sx={{
                  color: '#dfab01',
                  '&.Mui-checked': {
                    color: '#dfab01',
                  },
                  transform: 'scale(0.8)',
                  padding: '2px',
                }}
              />
            }
            label={WELL_FLAG}
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />

           <FormControlLabel
            value={PILLAR}
            control={
              <Radio
                sx={{
                  color: '#dfab01',
                  '&.Mui-checked': {
                    color: '#dfab01',
                  },
                  transform: 'scale(0.8)',
                  padding: '2px',
                }}
              />
            }
            label={PILLAR_FLAG}
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />

          <FormControlLabel
            value={PASSIVE_NODE}
            control={
              <Radio
                sx={{
                  color: '#dfab01',
                  '&.Mui-checked': {
                    color: '#dfab01',
                  },
                  transform: 'scale(0.8)',
                  padding: '2px',
                }}
              />
            }
            label={NODE_PASSIVE_FLAG}
            sx={{ '& .MuiFormControlLabel-label': { fontSize: '13px', color: 'white' } }}
          />
        </RadioGroup>
  <hr className='horizontalLineModal' style={{margin: '0px'}} />

       

        <div className="tableContainer">
          {filteredLogs.length === 0 ? (
            <p>Нет данных для отображения</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Тип</th>
                  <th>Статус</th>
                  <th>Пользователь</th>
                  <th>Дата</th>
                </tr>
              </thead>
              <tbody>
                {filteredLogs.map(log => (
                  <tr key={log.id}>
                    <td>{log.relevantId}</td>
                    <td>{log.relevantType}</td>
                    <td style={{
                      color:
                        log.statusComponentId === 1 ? 'green' :
                        log.statusComponentId === 2 ? 'red' :
                        log.statusComponentId === 3 ? '#b87d00' :
                        log.statusComponentId === 4 ? '#0050b8' : 'black',
                    }}>
                      {log.statusComponentName}
                    </td>
                    <td>{log.authorId}</td>
                    <td>{new Date(log.date).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class="buttonIsHideModal">
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalLog;

//   return (
//     <Dialog open={open} className="modalStyle">
//       <DialogContent>
//         <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #242424' }}>Логи</label>
//         <hr className='horizontalLineModal'/>
//         <div className="tableContainer">
//           {logs.length === 0 ? (
//             <p>Нет данных для отображения</p>
//           ) : (
//             <table>
//               <thead>
//                 <tr>
//                   <th>Id</th>
//                   <th>Тип</th>
//                   <th>Статус</th>
//                   <th>Пользователь</th>
//                   <th>Дата</th>  
//                 </tr>
//               </thead>
//               <tbody>
//               {logs.map(log => (
//                 <tr key={log.id}>
//                   <td>{log.relevantId}</td>
//                   <td>{log.relevantType}</td>
//                   <td style={{
//                     color: log.statusComponentId === 1 ? 'green' :
//                           log.statusComponentId === 2 ? 'red' :
//                           log.statusComponentId === 3 ? '#b87d00' :
//                           log.statusComponentId === 4 ? '#0050b8' : 'black',
                          
//                   }}>
//                     {log.statusComponentName}
//                   </td>
//                   <td>{log.authorId}</td>
//                   <td>{new Date(log.date).toLocaleString()}</td>
//                 </tr>
//               ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </DialogContent>

//       <DialogActions>
//         <Button onClick={onClose} class='buttonIsHideModal'>
//           Закрыть
//         </Button>
//       </DialogActions>

//       {/* Snackbar */}
//       <Snackbar
//         anchorOrigin={{
//           vertical: 'bottom',
//           horizontal: 'left',
//         }}
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         message={snackbarMessage}
//         ContentProps={{
//           style: {
//             color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
//           }
//         }}
//       />
//     </Dialog>
//   );
// };

// export default ModalLog;
